// commit our product/line data to state
const initProductLine = function (state, data) {
    // for when we need to revert state when they go from drilling down to 1 product, and change something on top
    state.defaultData = data
    state.data = data

    // 404 page
    if (data == null) return

    // reset this early so we have cleaner initial state.. We should consider initing controls to an empty state vs current initControls which fills with data
    state.controls.hasInteraction = false

    // for sku pages, only enable add to cart if we cascade to a sku, not the initial
    if (state.data.skuSlug) state.data.skuSlug = null

    state.originalSku = state.data.sku || ''

    state.mismatchedProduct = null

    // reset this so we always see green first, then turn to red.  Otherwise you'll see a red if the last line you saw was red (then it will flip to green)
    setIsGoodVehicleSoFar(state, true)
}

const initControls = function (state, { data, fitment }) {
    const controls = {}

    // single part ordering has no config
    if (!data.config)
        data.config = {
            drillTypes: [],
            nameMap: {},
            splitAt: null,
        }

    if (!data.config.drillTypes) data.config.drillTypes = []

    controls.drillConfig = getDrillConfig(data.config.drillTypes, data.config.splitAt) // drilldowns could be missing on single part ordering
    controls.labels = Object.assign(getYMMBBENameMap(controls.drillConfig.top), data.config.nameMap) // TODO: NameMap seems to be missing Notes even when it's filled in on master.. still need to probably fill in when it's not with a default
    controls.drills = getEmptyControls(controls.drillConfig.top, controls.labels)
    controls.groups = []
    controls.isGoodVehicleSoFar = true
    controls.hadBadAutoSelect = false
    controls.isShortCutFitment = false
    controls.hasOrderControlError = false
    controls.integration = data.config.integration
    controls.hasInteraction = false

    state.controls = controls

    // 3rd party OC integrations have no nextDrillAction
    if (!state.controls.integration)
        nextDrillAction.call(this, state, { data, groupValue: null, fitment })
}

// for pre-filled fitments to work we have to setup the controls to have a selected value so lower level controls can query the api correctly
const setupShortCutFitments = function (state, fitment) {
    state.controls.isShortCutFitment = true

    state.controls.drillConfig.fitment.forEach((drillType) => {
        getDrill(state.controls, drillType).currentValue = fitment[drillType]
    })
}

const setIsGoodVehicleSoFar = function (state, isGood) {
    state.controls.isGoodVehicleSoFar = isGood
}

const setHadBadAutoSelect = function (state, isGood) {
    state.controls.hadBadAutoSelect = isGood
}

const clearControls = function (state) {
    state.controls.drills = []
    state.controls.groups = []
}

const setRouteInfo = function (state, params) {
    let slug = params.productLine // vanish-tonneau-cover
    state.productLineSlug = slug

    if (params.skuSlug) slug += `/${params.skuSlug}` // vanish-tonneau-cover/91019
    state.slug = slug
}

const nextDrillAction = function (state, { data, groupValue, fitment }) {
    if (data.drill) {
        const drill = getDrill(state.controls, data.drill.type, groupValue)
        const optionCount = drill.options.length

        fillDrill(state, drill, data.drill.options)

        // auto select YMMBBE, but only if it's the first time the dropdown is filled!  Otherwise it will keep auto selecting when you try to select a diff YMM
        // If the current control state had an "bad" autoselect, meaning it tried to auto select something that it couldn't then we disable future autoselection for the currently init'ed OC's
        if (
            optionCount === 1 &&
            !state.controls.hadBadAutoSelect &&
            fitment[drill.type] &&
            fitment[drill.type] !== ''
        )
            drill.currentValue = fitment[drill.type]
    }

    if (data.product) {
        if (!groupValue) {
            if (
                state.originalSku &&
                state.originalSku !== data.product.sku &&
                !state.controls.hasInteraction
            ) {
                state.mismatchedProduct = data.product
                return
            }

            state.data = data.product
            this.$uiEvents.$emit('productViewed', { location: 'main' })
        } else {
            const group = getGroup(state.controls.groups, groupValue)
            fillGroupProduct(group, data.product)
            this.$uiEvents.$emit('productViewed', { location: 'group', index: group.index })
        }
    }

    if (data.groups) {
        const groups = []
        data.groups.forEach((obj, index) => {
            const group = getEmptyGroup(obj, state.data, index)

            // Found group with zero options and 1 product right off the bat (meyer-home-plow - 2017 Chevy Silverado 1500)
            if (obj.product) fillGroupProduct(group, obj.product)

            // when we get a group it should give us the first options of the first dropdown if it exists
            if (obj.drill) {
                group.drills = getEmptyControls(
                    state.controls.drillConfig.bottom,
                    state.controls.labels,
                    obj.title
                )
                /*
                  1/30/19 - Commented this out as it was triggering vuex strict mode alerts in dev.  I don't think this delay is needed anymore
                  because of the mounted() check in Drill...

                  Wait until the next tick to fill the drill so it's triggered by new options */
                // setTimeout(function() {
                fillDrill(state, group.drills[0], obj.drill.options)
                // }, 0)
            }
            groups.push(group)
        })

        state.controls.groups = groups
    }
}

const setSelectedValue = function (state, { sourceDrillType, newValue, groupValue }) {
    getDrill(state.controls, sourceDrillType, groupValue).currentValue = newValue
}

const setIsShortCutFitment = function (state, value) {
    state.controls.isShortCutFitment = value
}

// resets the controls 2 away from the source (since source will trigger the fill of next we have to skip over 1)
const resetControls = function (state, { sourceDrillType, groupValue }) {
    const controls = state.controls
    const drillConfig = controls.drillConfig

    // the only way to trigger this function is if you interact with OCs
    controls.hasInteraction = true

    // reset the controls below this one
    if (!groupValue) {
        const sourceIndex = drillConfig.top.indexOf(sourceDrillType)

        drillConfig.top.forEach((drillType, index) => {
            const drill = getDrill(controls, drillType)

            // reset the one you are about to fill next to make sure the drill doesn't think it should auto select the old value
            if (index > sourceIndex) drill.currentValue = -1

            // if it's a drill 2+ below this one, it should be disabled too
            if (index > sourceIndex + 1) drill.isDisabled = true
        })

        // they selected something on top, make sure the product line is they way they started out to clear out any product specific junk as it no longer applies
        // sometimes it looks a little flash when you have 1 product, then re-select something above as it could show the default data, then with option auto-selects could flash back to a product.. oh well.
        if (sourceIndex < drillConfig.top.length - 1) state.data = state.defaultData

        state.controls.groups = []
    } else {
        // reset controls below this one in the group
        const sourceIndex = drillConfig.bottom.indexOf(sourceDrillType)

        const group = getGroup(controls.groups, groupValue)

        group.product = group.defaultProduct

        drillConfig.bottom.forEach((drillType, index) => {
            if (index > sourceIndex) {
                const drill = getDrill(controls, drillType, groupValue)
                drill.currentValue = -1

                if (index > sourceIndex + 1) drill.isDisabled = true
            }
        })
    }
}

const setFromAd = (state, bool) => {
    state.fromAd = bool
}

const setHasOrderControlError = function (state, { groupValue, value }) {
    let control = state.controls
    if (groupValue) control = getGroup(control.groups, groupValue)
    if (control) control.hasOrderControlError = value
}

// when we get info back from the api we don't know if it's a drill on the top, or a drill embended deep in a group
export const getDrill = function (controlState, drillType, groupValue = null) {
    let drills = []

    if (!groupValue) drills = controlState.drills
    else drills = getGroup(controlState.groups, groupValue).drills

    for (let i = 0; i < drills.length; i++) {
        if (drills[i].type === drillType) return drills[i]
    }

    return null
}

export default {
    initProductLine,
    initControls,
    resetControls,
    clearControls,
    setRouteInfo,
    nextDrillAction,
    setSelectedValue,
    setFromAd,
    setIsGoodVehicleSoFar,
    setHadBadAutoSelect,
    setupShortCutFitments,
    setHasOrderControlError,
    setIsShortCutFitment,
}

// - private ----------------------------------------------------------------------------------------

// creates an empty group with some defaults
function getEmptyGroup(ocData, plData, index) {
    const obj = {}
    obj.title = ocData.title
    obj.groupValue = ocData.title // the same as title for now
    obj.index = index
    obj.hasOrderControlError = false

    const tempProduct = {}
    tempProduct.gallery = []
    tempProduct.gallery.push(ocData.image)
    tempProduct.basePrice = ocData.basePrice
    tempProduct.actualPrice = ocData.actualPrice
    tempProduct.hasMAPViolation = plData.hasMAPViolation
    tempProduct.shipping = plData.shipping
    tempProduct.name = 'Temp Group Product' // for debugging/giggles
    tempProduct.totalReviews = plData.totalReviews
    tempProduct.averageRating = plData.averageRating
    tempProduct.isPreOrder = plData.isPreOrder

    if (plData.discount) tempProduct.discount = plData.discount
    if (plData.promo) tempProduct.promo = plData.promo

    // used to reset the group vue if/when you re-select junk
    obj.defaultProduct = tempProduct
    obj.product = tempProduct
    return obj
}

// after a group has drilled to 1 product, update the group to show it
function fillGroupProduct(group, product) {
    group.product = product
}

// fills a drill with real options
function fillDrill(state, drill, newOptions) {
    const options = normalizeDrillOptions(newOptions)

    // TODO: Have the data in algolia be this way, then we an remove this shim
    // The ideal thing would be to not even show this option and auto-hide it (pline-fitment-hell branch) but then it becomes very hard to figure out
    // when to save their fitment as we use a native event to save their YMMBBE - which is much much safer than saving fitment everytime the selections change
    if (options.length === 1 && options[0].value === 'n-a') {
        switch (drill.type) {
            case 'bedSlug':
                options[0].text = 'All Beds'
                break
            case 'engineSlug':
                options[0].text = 'All Engines'
                break
            default:
                options[0].text = 'All Body Styles'
        }
    }

    // Sort options if more then one and contains numbers in first item
    if (options.length > 1 && /\d+/.test(options[0].text)) {
        options.sort((a, b) => {
            // if option text is a number (ie year dropdown) then just do a normal sort compare in descending order
            if (typeof a.text === 'number') return b.text - a.text
            // if its a string with numbers then run function to pull out the numbers so we can sort them
            const numA = getNumbers(a.text)
            const numB = getNumbers(b.text)
            // if first set of numbers is equal then we get a 0 which is falsey then sorts by second and third set of numbers if available
            return numA[0] - numB[0] || numA[1] - numB[1] || numA[2] - numB[2]
        })
    }

    options.unshift(getLabelOption(drill.type, state.controls.labels))
    drill.options = options
    drill.isDisabled = false
}

function getNumbers(str) {
    const words = str.split(' ')
    const numbers = []
    words.forEach((word) => {
        // if numbers represent a length (ie 3'10") then replace single quote with period and push to numbers array
        if (word.match(/\d+' *\d+(?=")/) !== null) {
            numbers.push(word.replace(/ *'/, '.') * 1000)
        } else {
            // remove any character that is not a number or period and push to numbers array
            // eslint-disable-next-line no-useless-escape
            const nbr = word.replace(/[^\.\d]/g, '') * 1000
            if (nbr) numbers.push(nbr)
        }
    })
    return numbers
}

// get a ref to the group you are searching for
function getGroup(groups, groupValue) {
    for (let i = 0; i < groups.length; i++) {
        if (groups[i].groupValue === groupValue) return groups[i]
    }

    return null
}

// creates a base drill obj with it's default option.  groupValue is used to pass group values to the drill so it can be sent with the drill actions
function getEmptyControls(drillTypes, labels, groupValue = null) {
    const arr = []

    drillTypes.forEach((drillType) => {
        const drill = {
            type: drillType,
            isFitment: isFitmentDrillType(drillType),
            isDisabled: true,
            currentValue: '-1',
            options: [],
            groupValue,
        }
        drill.options.push(getLabelOption(drillType, labels))
        arr.push(drill)
    })

    return arr
}

function isFitmentDrillType(drillType) {
    return ['year', 'makeSlug', 'modelSlug', 'bedSlug', 'bodySlug', 'engineSlug'].includes(
        drillType
    )
}

// gets the Select _____ menu option
function getLabelOption(drillType, labels) {
    return {
        value: '-1',
        text: `Select ${labels[drillType]}`,
        isDisabled: true,
    }
}

// takes the drilltypes configured and splits them into logical groups so we know what to expect on top, and bottom
function getDrillConfig(drillTypes, splitAt) {
    const obj = {
        top: [],
        bottom: [],
        splitAt,
        all: [],
        fitment: [],
        lastFitment: null,
    }

    const splitIndex = splitAt ? drillTypes.indexOf(splitAt) : 100

    drillTypes.forEach((drillType, index) => {
        if (index < splitIndex) {
            obj.top.push(drillType)

            if (isFitmentDrillType(drillType)) {
                obj.fitment.push(drillType)
                obj.lastFitment = drillType
            }
        } else if (index > splitIndex) obj.bottom.push(drillType)
    })

    obj.all = drillTypes // sometimes it's nice to know what order everything is in

    return obj
}

// kind of dumb, but name map doesn't include year-year, make-make etc.. it only includes attr/notes this gives a map for gaps
// currently using lower case values because the maps coming in are all lower case for no reason
// currently notes may/may not be passed from the api, they do have the option to fill it in.. but i think many probably aren't so we'll probably have to
// do some crap here to fill it in/normalize it
function getYMMBBENameMap(drillTypes) {
    const obj = {}
    drillTypes.forEach((drillType) => {
        if (
            [
                'year',
                'makeSlug',
                'modelSlug',
                'bedSlug',
                'bodySlug',
                'engineSlug',
                'notes',
            ].includes(drillType)
        )
            obj[drillType] = drillType.replace('Slug', '')
    })

    return obj
}

function normalizeDrillOptions(options) {
    const arr = []

    // if the drill is sluggified, use that for value
    options.forEach((option) => {
        // We need to make sure the value is always a string so the fitment system doesn't explode
        arr.push({
            value: option.slug ? option.slug : option.text.toString(),
            text: option.text,
            isDisabled: false,
        })
    })

    return arr
}
